import { useEffect, useState, useRef } from 'react';

/**
 * ✅ FASE 3: Hook para lazy loading com IntersectionObserver
 * Carrega seções apenas quando entram no viewport
 * 
 * @param threshold - Porcentagem do elemento visível para trigger (0-1)
 * @param rootMargin - Margem adicional para trigger antecipado
 */
export const useLazyLoad = (threshold = 0.1, rootMargin = '50px') => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isVisible) {
            setIsVisible(true);
            // Uma vez visível, para de observar
            observer.unobserve(element);
          }
        });
      },
      {
        threshold,
        rootMargin,
      }
    );

    observer.observe(element);

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [threshold, rootMargin, isVisible]);

  return { elementRef, isVisible };
};
